import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-text">
            <span>© {currentYear} Some Aditya Mandal. All rights reserved.</span>
          </div>
          <a href="/privacy.html" className="footer-privacy">Privacy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
